import { BrandBase } from '@abstractTypes/brand'
import { Brand } from '@abstractTypes/graphqlTypes'

export const formatBrandBaseIntoBrand = (brandBase: BrandBase, baseUrl: string): Brand => ({
  ...brandBase,
  url: [baseUrl, brandBase.id].join('/'),
})
